import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar      from './components/Navbar';
import Footer      from './components/Footer';
import WhatsAppFAB from './components/WhatsAppFAB';
import ScrollToTop from './components/ScrollToTop';
import Home       from './pages/Home';
import Services   from './pages/Services';
import Industries from './pages/Industries';
import About      from './pages/About';
import Contact    from './pages/Contact';
import Portfolio  from './pages/Portfolio';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/services"   element={<Services />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/portfolio"  element={<Portfolio />} />
          <Route path="/about"      element={<About />} />
          <Route path="/contact"    element={<Contact />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFAB />
    </Router>
  );
}

export default App;
